import { render, staticRenderFns } from "./vendorStatus.vue?vue&type=template&id=7c61c580&"
import script from "./vendorStatus.vue?vue&type=script&lang=js&"
export * from "./vendorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports